export const REDUCE_BROKER_ELEMENT = 'REDUCE_BROKER_ELEMENT';
export const REDUCE_BROKER = 'REDUCE_BROKER';
export const REDUCE_BROKER_HANDLE_CODE = 'REDUCE_BROKER_HANDLE_CODE';
export const REDUCE_BROKER_HANDLE_IMAGE = 'REDUCE_BROKER_HANDLE_IMAGE';
export const REDUCE_BROKER_HANDLE_ERROR = 'REDUCE_BROKER_HANDLE_ERROR';

export const GET_BROKER = 'GET_BROKER';
export const UPDATE_BROKER = 'UPDATE_BROKER';
export const QUERY_BROKERS = 'QUERY_BROKERS';
export const GET_BROKER_HANDLE = 'GET_BROKER_HANDLE';
export const UPDATE_BROKER_HANDLE = 'UPDATE_BROKER_HANDLE';

export const EXECUTE_BROKER_ACTION = 'EXECUTE_BROKER_ACTION';
export const REDUCE_QUERY_ELEMENT = 'REDUCE_BROKER_QUERY_ELEMENT';
export const REDUCE_BROKERS = 'REDUCE_BROKERS';
export const REDUCE_ENTITY = 'REDUCE_ENTITY';
export const REDUCE_SOCIAL_MEDIA_AND_BOOKING_SETUP = 'REDUCE_SOCIAL_MEDIA_AND_BOOKING_SETUP';
export const REDUCE_SOCIAL_AND_BOOKING_SETUP_ELEMENT = 'REDUCE_SOCIAL_AND_BOOKING_SETUP_ELEMENT';
export const GET_SOCIAL_MEDIA_AND_BOOKING_SETUP = 'GET_SOCIAL_MEDIA_AND_BOOKING_SETUP';
export const UPDATE_SOCIAL_MEDIA_AND_BOOKING_SETUP = 'UPDATE_SOCIAL_MEDIA_AND_BOOKING_SETUP';

export const GET_BROKER_SETTINGS = 'GET_BROKER_SETTINGS';
export const REDUCE_BROKER_SETTINGS = 'REDUCE_BROKER_SETTINGS';
export const REDUCE_BROKER_SETTINGS_ELEMENT = 'REDUCE_BROKER_SETTINGS_ELEMENT';
export const UPSERT_BROKER_SETTINGS = 'UPSERT_BROKER_SETTINGS';

// Velocity Import
export const GET_VELOCITY_API_KEY = 'GET_VELOCITY_API_KEY';
export const SET_VELOCITY_API_KEY = 'SET_VELOCITY_API_KEY';
export const GET_VELOCITY_WEBHOOK = 'GET_VELOCITY_WEBHOOK';
export const SET_VELOCITY_WEBHOOK = 'SET_VELOCITY_WEBHOOK';
export const GET_VELOCITY_SECURITY_KEY = 'GET_VELOCITY_SECURITY_KEY';
export const ENABLE_VELOCITY_WEBHOOK = 'ENABLE_VELOCITY_WEBHOOK';
export const TRIGGER_VELOCITY_IMPORT = 'TRIGGER_VELOCITY_IMPORT';
export const GET_VELOCITY_IMPORT_HISTORY = 'GET_VELOCITY_IMPORT_HISTORY';
export const GET_VELOCITY_IMPORT_DOWNLOAD = 'GET_VELOCITY_IMPORT_DOWNLOAD';
export const REDUCE_VELOCITY_CONFIG = 'REDUCE_VELOCITY_CONFIG';
export const REDUCE_VELOCITY_CONFIG_ELEMENT = 'REDUCE_VELOCITY_CONFIG_ELEMENT';
export const REDUCE_VELOCITY_IMPORT_HISTORY = 'REDUCE_VELOCITY_IMPORT_HISTORY';
